
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alpha/profile/[id]",
      function () {
        return require("private-next-pages/alpha/profile/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alpha/profile/[id]"])
      });
    }
  